import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_169: DocMigration = {
  maxSchemaVersion: "0.0.169",
  description: "Remove the unused ParamRef type",
  apply(json: any) {
    if (json.paramRefs) {
      delete json.paramRefs;
    }

    return json;
  },
};

export default migration_0_0_169;
